import { useNavigate } from "react-router-dom";
import { Shield, Store, LogOut } from "lucide-react";

// Admin's top-right nav: Admin Panel | Store (current one highlighted) + Logout.
export default function AdminTopNav({ current, onLogout, full = false }) {
  const navigate = useNavigate();
  const item = (key, label, Icon, to) => {
    const on = current === key;
    return (
      <button
        type="button"
        data-testid={`topnav-${key}${full ? "-m" : ""}`}
        aria-current={on ? "page" : undefined}
        onClick={() => !on && navigate(to)}
        className={`flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-semibold transition-[background-color,color,box-shadow] ${full ? "flex-1" : ""} ${
          on ? "bg-blue-700 text-white shadow-md shadow-blue-700/25" : "text-blue-800 hover:bg-white"
        }`}
      >
        <Icon className="h-4 w-4" /> {label}
      </button>
    );
  };
  return (
    <div className={`flex items-center gap-2 ${full ? "w-full" : ""}`}>
      <div className={`flex items-center gap-0.5 rounded-xl bg-blue-50 p-1 ring-1 ring-blue-100 ${full ? "flex-1" : ""}`}>
        {item("admin", "Admin Panel", Shield, "/admin")}
        {item("store", "Store", Store, "/dashboard")}
      </div>
      <button
        type="button"
        data-testid={`topnav-logout${full ? "-m" : ""}`}
        onClick={onLogout}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-lg border border-slate-200 px-3 py-2.5 text-sm font-semibold text-slate-600 transition-colors hover:border-red-200 hover:bg-red-50 hover:text-red-600"
      >
        <LogOut className="h-4 w-4" /> Logout
      </button>
    </div>
  );
}
